// [BD feat] Category Row — bd-category-row.js
// Same drag-to-pan behavior as assets/bd-featured-product-list.js, scoped to this section's
// own .bd-category-row__track instead (kept as a separate copy rather than broadening that
// file's selector, so this new section can't regress the already-shipped featured-product-list
// row). See that file's header comment for the full reasoning behind the approach: plain
// overflow-x: auto with a hidden scrollbar, mouse-only click-and-drag pan added for fine
// pointers (touch/trackpad already pan natively), no scrollTo/snap-to-nearest-cell.
(function () {
  'use strict';

  function initTrack(track) {
    if (track.hasAttribute('data-bd-category-row-init')) return;
    track.setAttribute('data-bd-category-row-init', '');

    if (!window.matchMedia('(pointer: fine)').matches) return;

    var dragged = false;
    var startX = 0;
    var startScrollLeft = 0;

    function onMouseMove(event) {
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 3) dragged = true;
      track.scrollLeft = startScrollLeft - delta;
    }

    function onMouseUp() {
      track.classList.remove('is-dragging');
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    }

    track.addEventListener('mousedown', function (event) {
      if (event.button !== 0) return;
      dragged = false;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    });

    track.addEventListener('click', function (event) {
      if (dragged) {
        event.preventDefault();
        dragged = false;
      }
    }, true);
  }

  function initScope(scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('.bd-category-row__track').forEach(initTrack);
  }

  initScope(document);

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector('.bd-category-row__track')) return;
    initScope(event.target);
  });
})();
// [/BD feat] Category Row
